import { useQuery } from '@tanstack/react-query';
import { brgsApi } from '../api/brgs';
import { BrgListItemDto } from '../types';

export function useBrgList() {
  return useQuery<BrgListItemDto[], Error>({
    queryKey: ['brgs'],
    queryFn: () => brgsApi.list(),
  });
}
